import styled from 'styled-components'

export const Container = styled.div`
display: flex;
width: 100%;
flex-direction: ${({flex}) => !flex && 'column'};
padding: ${({flex}) => flex && '0 200px'};
  margin-top: 64px;
`

export const Wrapper = styled.div`
display: flex;
justify-content: space-between;
flex-wrap: wrap;
margin-left: 32px;
`

export const Section = styled.div`
padding: 0 200px;
`